var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper" }, [
    _c("div", { staticClass: "ibox-title" }),
    _vm._v(" "),
    _c("div", { attrs: { id: "popupChild" } }, [
      _c(
        "p",
        {
          staticClass: "report_tit",
          staticStyle: {
            "font-size": "26px",
            "font-weight": "bold",
            "text-align": "center",
            margin: "10px 0"
          }
        },
        [_vm._v("儿童健康检查表")]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            float: "left",
            width: "33.33333%",
            "text-align": "left"
          }
        },
        [_vm._v("班级：" + _vm._s(_vm.popupList.className))]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            float: "left",
            width: "33.33333%",
            "text-align": "center"
          }
        },
        [
          _vm._v(
            "机构名称：" +
              _vm._s(
                _vm.popupList.gardenName == undefined
                  ? _vm.popupList.hospital
                  : _vm.popupList.gardenName
              )
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            float: "left",
            width: "33.33333%",
            "text-align": "right",
            "margin-top": "-5px"
          }
        },
        [
          _c("input", {
            staticClass: "but",
            attrs: { type: "button", value: "立即打印" },
            on: {
              click: function($event) {
                _vm.print()
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "report_tab",
          staticStyle: { width: "100%", "border-collapse": "collapse" },
          attrs: { id: "report_tab" }
        },
        [
          _c("tbody", [
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("姓名")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-right": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { id: "pi_childName" }
                },
                [_vm._v(_vm._s(_vm.popupList.childName))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-right": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("性别")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-right": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "sex" }
                },
                [_vm._v(_vm._s(_vm.popupList.sex))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-right": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("年龄")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-right": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "age" }
                },
                [_vm._v(_vm._s(_vm.popupList.age))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-bottom": "1px solid #ddd",
                    "border-top": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("出生日期")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "0",
                    border: "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "birthday" }
                },
                [_vm._v(_vm._s(_vm.popupList.birthday))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    width: "12.3%",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("既往病史")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "9", showvalue: "1048" }
                },
                [_vm._v(_vm._s(_vm.popupItem.jwbs))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    width: "12.3%",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("过敏史")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "4", showvalue: "1049" }
                },
                [_vm._v(_vm._s(_vm.popupItem.gms))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("儿童家长确认签名")]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  "border-left": "1px solid #ddd",
                  "border-bottom": "1px solid #ddd",
                  "border-right": "1px solid #ddd",
                  height: "40px",
                  "text-align": "center",
                  "font-size": "12px"
                },
                attrs: { colspan: "3" }
              })
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    width: "28px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "5" }
                },
                [_vm._v("体格检查")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "81px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("体重")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "80px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c("span", { attrs: { showvalue: "1003" } }, [
                    _vm._v(_vm._s(_vm.popupItem.weight))
                  ]),
                  _c(
                    "span",
                    { staticStyle: { float: "right", "margin-right": "5px" } },
                    [_vm._v("kg")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "80px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("评价")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "65px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "weightComment" }
                },
                [_vm._v(_vm._s(_vm.popupItem.weightComment))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "65px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("身高")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "80px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c("span", { attrs: { showvalue: "1002" } }, [
                    _vm._v(_vm._s(_vm.popupItem.height))
                  ]),
                  _c(
                    "span",
                    { staticStyle: { float: "right", "margin-right": "5px" } },
                    [_vm._v("cm")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "65px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("评价")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "80px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "heightComment" }
                },
                [_vm._v(_vm._s(_vm.popupItem.heightComment))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "65px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("皮肤")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    width: "65px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1014" }
                },
                [_vm._v(_vm._s(_vm.popupItem.skin))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "2" }
                },
                [_vm._v("眼")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("左")]
                  ),
                  _c("span", { attrs: { showvalue: "1019" } }, [
                    _vm._v(_vm._s(_vm.popupItem.LEye))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "2" }
                },
                [_vm._v("视力")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("左")]
                  ),
                  _c("span", { attrs: { showvalue: "1017" } }, [
                    _vm._v(_vm._s(_vm.popupItem.LSight))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "2" }
                },
                [_vm._v("耳")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("左")]
                  ),
                  _c("span", { attrs: { showvalue: "1021" } }, [
                    _vm._v(_vm._s(_vm.popupItem.LEar))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "2" }
                },
                [_vm._v("口腔")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("牙齿数")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "1025" }
                },
                [_vm._v(_vm._s(_vm.popupItem.teethNum))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("右")]
                  ),
                  _c("span", { attrs: { showvalue: "1020" } }, [
                    _vm._v(_vm._s(_vm.popupItem.REye))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("右")]
                  ),
                  _c("span", { attrs: { showvalue: "1018" } }, [
                    _vm._v(_vm._s(_vm.popupItem.RSight))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "fl ml5",
                      staticStyle: { float: "left", "margin-left": "5px" }
                    },
                    [_vm._v("右")]
                  ),
                  _c("span", { attrs: { showvalue: "1022" } }, [
                    _vm._v(_vm._s(_vm.popupItem.REar))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("龋齿数")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "1026" }
                },
                [_vm._v(_vm._s(_vm.popupItem.Caries))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("头颅")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1031" }
                },
                [_vm._v(_vm._s(_vm.popupItem.tl))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("胸廓")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "1032" }
                },
                [_vm._v(_vm._s(_vm.popupItem.xk))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("脊柱四肢")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1033" }
                },
                [_vm._v(_vm._s(_vm.popupItem.jzsz))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("咽部")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2", showvalue: "1024" }
                },
                [_vm._v(_vm._s(_vm.popupItem.throat))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("心肺")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1027" }
                },
                [_vm._v(_vm._s(_vm.popupItem.lung))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("肝脾")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1029" }
                },
                [_vm._v(_vm._s(_vm.popupItem.liver))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("外生殖器")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { showvalue: "1034" }
                },
                [_vm._v(_vm._s(_vm.popupItem.wszq))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  }
                },
                [_vm._v("其他")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "3", showvalue: "1051" }
                },
                [_vm._v(_vm._s(_vm.popupItem.qttg))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    width: "28px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { rowspan: "2" }
                },
                [_vm._v("辅助检查")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("血红蛋白（Hb）")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "3", showvalue: "1004" }
                },
                [_vm._v(_vm._s(_vm.popupItem.HB))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("丙氨酸氨基转移酶（ALT）")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "3", showvalue: "1039" }
                },
                [_vm._v(_vm._s(_vm.popupItem.basajzam))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("其他")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "8", showvalue: "1052" }
                },
                [_vm._v(_vm._s(_vm.popupItem.qtfz))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("检查结果")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "3", showvalue: "checkResult" }
                },
                [_vm._v(_vm._s(_vm.popupList.checkResult))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "2" }
                },
                [_vm._v("医生建议")]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "text-align": "left",
                    padding: "10px",
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd"
                  },
                  attrs: { colspan: "4", showvalue: "doctorSuggestion" }
                },
                [_vm._v(_vm._s(_vm.popupList.doctorSuggestion))]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "border-left": "1px solid #ddd",
                    "border-bottom": "1px solid #ddd",
                    "border-right": "1px solid #ddd",
                    height: "40px",
                    "text-align": "center",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "11" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "whalf fl",
                      staticStyle: {
                        float: "left",
                        width: "50%",
                        height: "30px",
                        "text-align": "left",
                        margin: "10px 0",
                        "box-sizing": "border-box",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _vm._v("医生签名："),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            height: "30px",
                            "line-height": "30px",
                            "text-align": "center"
                          },
                          attrs: { showvalue: "doctor" }
                        },
                        [_vm._v(_vm._s(_vm.popupList.doctor))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "whalf fl",
                      staticStyle: {
                        float: "left",
                        width: "50%",
                        height: "30px",
                        "text-align": "left",
                        margin: "10px 0",
                        "box-sizing": "border-box",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _vm._v("检查单位："),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "inline-block",
                            height: "30px",
                            "line-height": "30px",
                            "text-align": "center"
                          },
                          attrs: { showvalue: "hospital" }
                        },
                        [_vm._v(_vm._s(_vm.popupList.hospital))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "whalf fl",
                      staticStyle: {
                        float: "left",
                        width: "50%",
                        height: "30px",
                        "text-align": "left",
                        margin: "10px 0",
                        "box-sizing": "border-box",
                        "padding-left": "10px"
                      }
                    },
                    [
                      _vm._v("\n                体检日期：\n                "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "40px",
                            display: "inline-block",
                            height: "30px",
                            "line-height": "30px",
                            "text-align": "center"
                          },
                          attrs: { id: "checkyear" }
                        },
                        [_vm._v(_vm._s(_vm.checkyear))]
                      ),
                      _vm._v("年\n                "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "40px",
                            display: "inline-block",
                            height: "30px",
                            "line-height": "30px",
                            "text-align": "center"
                          },
                          attrs: { id: "checkmonth" }
                        },
                        [_vm._v(_vm._s(_vm.checkmonth))]
                      ),
                      _vm._v("月\n                "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            width: "40px",
                            display: "inline-block",
                            height: "30px",
                            "line-height": "30px",
                            "text-align": "center"
                          },
                          attrs: { id: "checkday" }
                        },
                        [_vm._v(_vm._s(_vm.checkday))]
                      ),
                      _vm._v("日\n              ")
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "whalf fl",
        staticStyle: {
          float: "left",
          width: "50%",
          height: "30px",
          "text-align": "left",
          margin: "10px 0",
          "box-sizing": "border-box",
          "padding-left": "10px"
        }
      },
      [
        _c("span", { staticStyle: { "padding-left": "80px" } }, [
          _vm._v("（检查单位盖章）")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5e78c9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5e78c9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/physical/childPhyPrintSd.vue
// module id = null
// module chunks = 